import React from 'react';
import { PredefinedPhrase } from '../../PredefinedPhrasesSetup/PredefinedPhrasesList';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import PredefinedPhraseSelection from './PredefinedPhraseSelection';
import { PhraseType } from '../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	onSelect: (item: PredefinedPhrase) => void;
	type: PhraseType;
}

const PredefinedPhraseSelectionModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.predefinedPhraseSelection.modalTitle'
			{...props}>
			<PredefinedPhraseSelection type={props.type} onSelect={props.onSelect} />
		</BaseModal>
	);
};

export default PredefinedPhraseSelectionModal;
